import { StateService } from "@uirouter/angularjs";
import { Component } from "../../../component-decorator";
import * as moment from "moment";

@Component({
  componentName: "appAtendimentoDetalhes",
  template: require("./detalhes.component.html"),
})
export class AtendimentoDetalhesComponent implements angular.IController {
  public ticketId;
  public pageTitle = "Solicitações";
  public mayAnswer = false;
  public comments = [];
  public refreshing = false;
  public ticket;

  constructor(
    private AtendimentoResource,
    private AtendimentoComentarioResource,
    $state: StateService,
    private $mdToast,
    private localStorageService
  ) {
    this.ticketId = $state.params.ticketId;
  }

  async $onInit() {
    try {
      this.refreshing = true;

      const ticketResult = await this.AtendimentoResource.get({
        id: this.ticketId,
      }).$promise;
      this.ticket = ticketResult;
      this.pageTitle =
        "Solicitações > " + ticketResult.subject + " (" + ticketResult.id + ")";
      return await this.atualizarComentarios();
    } catch (e) {
      this.refreshing = false;
    }
  }

  async atualizarComentarios() {
    try {
      const commentResult = await this.AtendimentoComentarioResource.query({
        ticketId: this.ticketId,
      }).$promise;

      this.comments = commentResult;
      this.refreshing = false;
      this.mayAnswer =
        ["open", "new", "pending"].includes(this.ticket.status) ||
        (this.ticket.status === "solved" && this.countOpenDays() <= 5);
    } catch (e) {
      this.refreshing = false;
    }
  }

  formataCorpoComentario(str) {
    return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br/>$2");
  }

  respostaSucesso = () => this.respostaSucessoInner();

  private respostaSucessoInner() {
    const eventParams = {
      ticketId: this.ticketId,
      email: this.localStorageService.get("user").email,
    };

    const toast = this.$mdToast
      .simple()
      .textContent("Recebemos a sua resposta!")
      .action("OK");
    toast._options.position = "top right";

    this.$mdToast.show(toast);

    window.scrollTo({ top: 0, left: 0 });

    this.atualizarComentarios();
  }

  public countOpenDays() {
    return moment().diff(moment(this.ticket.updatedAt), "days");
  }

  // Called from the template on every digest, also before the ticket loads (or when it fails to load).
  public closed() {
    return !!this.ticket && ["solved", "closed"].includes(this.ticket.status);
  }
}
